import { getUserSlug } from './users';

const getProfilePageRedirectProps = ({ user, isUnauthorizedUser, variant }) => {
  const slug = getUserSlug(user);
  if (user?.id) {
    if (isUnauthorizedUser) {
      return {
        name: slug ? 'ProfilePageVariantCustomURL' : 'ProfilePageVariant',
        params: slug ? { slug, variant } : { id: user.id.uuid, variant },
      };
    }
    return {
      name: slug ? 'ProfilePageCustomURL' : 'ProfilePage',
      params: slug ? { slug } : { id: user.id.uuid },
    };
  }
  return { name: 'ProfileBasePage' };
};

export default getProfilePageRedirectProps;
